/**
 * Query params for the Calendar's planned-tasks fetch (GET /api/tasks).
 *
 * - planned_from / planned_to: the visible grid's first and last day (YYYY-MM-DD).
 * - mine: viewers without the Tasks screen only ever see their own tasks.
 * - assigned_employee_id: the Calendar's Employee filter. Tasks have a single
 *   assignee, so a selected employee shows only tasks assigned to them —
 *   unassigned tasks are hidden until "All Employees" is chosen again. The
 *   server still ANDs the caller's own task scope on top, so a manager can
 *   never widen what they see by picking someone they don't manage.
 */
export function buildPlannedTaskParams({ startDate, endDate, canSeeTasksScreen, filterEmployee }) {
  const params = { planned_from: startDate, planned_to: endDate };
  if (!canSeeTasksScreen) params.mine = true;
  if (filterEmployee !== '' && filterEmployee !== null && filterEmployee !== undefined) {
    params.assigned_employee_id = filterEmployee;
  }
  return params;
}
